import { Select } from '@zorro/design-system/v2/Select';
import { Group, Text } from '@zorro/web/design-system';

const selectOptions = [
  { value: '25', label: '25 per page' },
  { value: '50', label: '50 per page' },
  { value: '100', label: '100 per page' },
  { value: '150', label: '150 per page' },
];

type PaginationSelectProps = {
  from: number;
  to: number;
  totalRecords: number;
  handlePageSizeChange: (value?: string | null) => void;
  pageSize: number;
};

export const PaginationSelect = ({
  from,
  to,
  totalRecords,
  handlePageSizeChange,
  pageSize,
}: PaginationSelectProps) => {
  return (
    <Group gap={10} align="center">
      <Text size="xs" c="zorroCoal.9">{`${from}-${to} / ${totalRecords}`}</Text>
      <Select
        onChange={handlePageSizeChange}
        value={pageSize?.toString()}
        data={selectOptions}
        size="xs"
        w="8rem"
      />
    </Group>
  );
};
